/******* 
 * @description:
 *  自定义指令：v-formEnter="searchFunc"
 * - 配置在el-form标签中，可以自动匹配该表单下所有的input，给它们全部添加@keyup.enter.native事件，自动执行查询方法
 * @return {*}
 */
export default {
    bind: function (el, bindings) {
        const inputs = el.querySelectorAll("input");
        const fn = bindings.value;
        const keyUp = (e) => {
            if (e.code !== 'Enter') return;
            typeof fn === 'function' && fn();
        }
        [...inputs].forEach(input => {
            input.onfocus = () => input.addEventListener("keyup", keyUp)
            input.onblur = () => input.removeEventListener("keyup", keyUp)
        })
    }
}


// WEBPACK FOOTER //
// ./src/directives/formEnter.js